/* Vertastone project viewer. Full-screen, swipeable, keyboard friendly.
   VSViewer.open(projectId, photoIndex?, idList?)  — idList = order for prev/next project.
   Data: window.VS_PROJECTS (projects.js). Images: window.VS_IMG_BASE || 'assets/photos/'. */
(function () {
  var P = window.VS_PROJECTS || [];
  var BASE = function () { return window.VS_IMG_BASE || 'assets/photos/'; };
  var HAS_SMALL = /^(gal-|photo-0|app-|retaining-wall|water-feature)/;
  var full = function (n) { return BASE() + n; };
  var small = function (n) { return BASE() + (HAS_SMALL.test(n) ? n.replace(/\.webp$/, '-800.webp') : n); };
  var byId = function (id) { for (var i = 0; i < P.length; i++) if (P[i].id === id) return P[i]; return null; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var ARROW = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (d < 0 ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6') + '"/></svg>'; };

  var dlg = document.createElement('dialog');
  dlg.className = 'vv';
  dlg.setAttribute('aria-labelledby', 'vvTitle');
  dlg.innerHTML =
    '<div class="vv__wrap">' +
      '<div class="vv__stage">' +
        '<div class="vv__frame" id="vvFrame"><img id="vvImg" alt="">' +
          '<div class="vv__top"><span class="vv__stagechip" id="vvStage"></span><button class="vv__close" type="button" id="vvClose" aria-label="Close project">&times;</button></div>' +
          '<button class="vv__nav vv__nav--prev" type="button" id="vvPrev" aria-label="Previous photo">' + ARROW(-1) + '</button>' +
          '<button class="vv__nav vv__nav--next" type="button" id="vvNext" aria-label="Next photo">' + ARROW(1) + '</button>' +
        '</div>' +
        '<div class="vv__thumbs" id="vvThumbs" role="group" aria-label="Project photos"></div>' +
      '</div>' +
      '<aside class="vv__info">' +
        '<div><span class="vv__type" id="vvType"></span><h2 class="vv__title" id="vvTitle"></h2></div>' +
        '<p class="vv__cap" id="vvCap"></p>' +
        '<dl class="vv__meta" id="vvMeta"></dl>' +
        '<div class="vv__story" id="vvStory"><h3>The build</h3><ul class="vv__steps" id="vvSteps"></ul></div>' +
        '<div class="vv__ctas"><a class="vv__cta1" href="/pages/hire-a-pro">Want one like this? Find a pro &rarr;</a><a class="vv__cta2" href="/pages/become-a-pro">Learn to build it</a></div>' +
        '<div class="vv__proj"><button type="button" id="vvPP"></button><button type="button" id="vvNP"></button></div>' +
        '<p class="vv__hint"><span class="vv__count" id="vvCount"></span> &middot; Use arrow keys or swipe</p>' +
      '</aside>' +
    '</div>';
  document.body.appendChild(dlg);
  var $ = function (id) { return dlg.querySelector('#' + id); };
  var img = $('vvImg'), thumbs = $('vvThumbs');
  var cur = null, idx = 0, list = [], opener = null, token = 0;

  function show(i) {
    var ph = cur.photos;
    idx = (i + ph.length) % ph.length;
    var p = ph[idx], my = ++token;
    img.classList.add('is-out');
    setTimeout(function () {
      if (my !== token) return;
      img.classList.add('is-low');
      img.src = small(p[0]); img.alt = p[2] || cur.t;
      img.classList.remove('is-out');
      var hi = new Image();
      hi.onload = function () { if (my === token) { img.src = hi.src; img.classList.remove('is-low'); } };
      hi.src = full(p[0]);
    }, 120);
    $('vvStage').textContent = p[1] || 'Photo';
    $('vvCount').textContent = (idx + 1) + ' / ' + ph.length;
    $('vvPrev').disabled = $('vvNext').disabled = ph.length < 2;
    thumbs.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-current', String(j === idx)); if (j === idx && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center' }); });
    $('vvSteps').querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-current', String(b.dataset.s === p[1])); });
    [idx + 1, idx - 1].forEach(function (k) { var q = ph[(k + ph.length) % ph.length]; if (q) { var pre = new Image(); pre.src = full(q[0]); } });
    try { history.replaceState(null, '', '#project=' + cur.id + (idx ? '&photo=' + (idx + 1) : '')); } catch (e) {}
  }

  function load(p, i) {
    cur = p;
    $('vvType').textContent = p.type || '';
    $('vvTitle').textContent = p.t;
    $('vvCap').textContent = p.c || '';
    var meta = '<dt>Built by</dt><dd>' + esc(p.by) + '</dd>';
    if (p.where) meta += '<dt>Where</dt><dd>' + esc(p.where) + '</dd>';
    if (p.when) meta += '<dt>When</dt><dd>' + esc(p.when) + '</dd>';
    meta += '<dt>Photos</dt><dd>' + p.photos.length + '</dd>';
    $('vvMeta').innerHTML = meta;
    thumbs.innerHTML = p.photos.map(function (ph, j) { return '<button type="button" aria-label="Photo ' + (j + 1) + ': ' + esc(ph[1]) + '"><img src="' + small(ph[0]) + '" alt="" loading="lazy"></button>'; }).join('');
    var stages = [];
    p.photos.forEach(function (ph) { if (ph[1] && stages.indexOf(ph[1]) < 0) stages.push(ph[1]); });
    $('vvStory').hidden = stages.length < 2;
    $('vvSteps').innerHTML = stages.map(function (s) { return '<li><button type="button" data-s="' + esc(s) + '">' + esc(s) + '</button></li>'; }).join('');
    var k = list.indexOf(p.id), pp = byId(list[k - 1]), np = byId(list[k + 1]);
    $('vvPP').disabled = !pp; $('vvNP').disabled = !np;
    $('vvPP').innerHTML = pp ? '<small>&larr; Previous project</small>' + esc(pp.t) : '';
    $('vvNP').innerHTML = np ? '<small>Next project &rarr;</small>' + esc(np.t) : '';
    show(i == null ? (p.cover || 0) : i);
  }

  function open(id, i, ids) {
    var p = byId(id); if (!p) return;
    list = ids && ids.length ? ids : P.map(function (x) { return x.id; });
    opener = document.activeElement;
    load(p, i);
    if (!dlg.open) dlg.showModal();
    $('vvClose').focus();
  }
  function stepProject(d) { var k = list.indexOf(cur.id) + d, p = byId(list[k]); if (p) load(p, null); }

  $('vvPrev').addEventListener('click', function () { show(idx - 1); });
  $('vvNext').addEventListener('click', function () { show(idx + 1); });
  $('vvClose').addEventListener('click', function () { dlg.close(); });
  $('vvPP').addEventListener('click', function () { stepProject(-1); });
  $('vvNP').addEventListener('click', function () { stepProject(1); });
  thumbs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) show([].indexOf.call(thumbs.children, b)); });
  $('vvSteps').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    for (var j = 0; j < cur.photos.length; j++) if (cur.photos[j][1] === b.dataset.s) { show(j); return; }
  });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
  });
  dlg.addEventListener('click', function (e) { if (e.target === $('vvFrame')) dlg.close(); });
  dlg.addEventListener('close', function () {
    token++;
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    if (opener && opener.focus) opener.focus();
  });
  // swipe
  var sx = null, sy = 0;
  $('vvFrame').addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  $('vvFrame').addEventListener('touchend', function (e) {
    if (sx == null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(idx + (dx < 0 ? 1 : -1));
  });

  window.VSViewer = { open: open, projects: P, small: small, full: full };

  // deep link: #project=<id>&photo=<n>
  var m = location.hash.match(/project=([a-z0-9-]+)(?:&photo=(\d+))?/);
  if (m && byId(m[1])) setTimeout(function () { open(m[1], m[2] ? (+m[2] - 1) : null); }, 300);
})();
